<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">预算拆分</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="height:20px"></div>
				<div class="findcontent">
					<div class="findTitle">预算拆分单</div>
					<div class="formlist">
						<el-form :inline="true" :model="formInline" class="demo-form-inline">
							<el-form-item label="预算拆分单编号">
								<el-input v-model="formInline.budgetSplit.budget_number" style="width:160px"
									size="small" readonly></el-input>
							</el-form-item>
							<el-form-item label="年度">
								<el-date-picker v-model="formInline.budgetSplit.annual" value-format="yyyy" type="year"
									placeholder="选择年" size="small" style="width:120px">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="月份">
								<el-date-picker v-model="formInline.budgetSplit.monthly" value-format="MM" format="MM"
									type="month" placeholder="选择月" size="small" style="width:120px">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="项目名称">
								<el-select v-model="formInline.budgetSplit.project_id" clearable style="width:160px"
									 @change="proClick" size="small" filterable>
									<el-option v-for="item in projectList" :key="item.id" :label="item.project_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="集团架构">
								<el-input v-model="formInline.budgetSplit.group_structure" style="width:160px"
									size="small" readonly></el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input v-model="formInline.budgetSplit.notes" style="width:160px" size="small">
								</el-input>
							</el-form-item>
							<el-form-item label="拆分说明">
								<el-input v-model="formInline.budgetSplit.spare5" style="width:260px" size="small">
								</el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div class="btnicon">
					<div class="btnview" @click="addtable()">
						<img src="../../../assets/budget/新增11.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">新增</span>
					</div>
					<div class="btnview" @click="Add()">
						<img src="../../../assets/budget/保存.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">保存</span>
					</div>
				</div>

				<div class="tabs">
					<div>
						<el-table :header-cell-style="{background:'#d4e9e2',color:'#000000'}"
							:row-class-name="tableRowClassName" ref="multipleTable" :data="formInline.detailedList"
							tooltip-effect="dark" style="width: 100%;" height="450"
							@selection-change="handleSelectionChange" border>
							<el-table-column align="center" label="序号" width="50">
								<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
							</el-table-column>
							<el-table-column prop="budget_classification" align="center" label="预算分类">
								<template slot-scope="scope">
									<el-input v-model="scope.row.budget_classification" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="budget_name" align="center" label="预算名称">
								<template slot-scope="scope">
									<el-input v-model="scope.row.budget_name" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="year_change" align="center" label="变更年份">
								<template slot-scope="scope">
									<el-input v-model="scope.row.year_change" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="change_month" align="center" label="变更月份">
								<template slot-scope="scope">
									<el-input v-model="scope.row.change_month" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="pre_change_architecture" align="center" label="架构(变更前)">
								<template slot-scope="scope">
									<el-input v-model="scope.row.pre_change_architecture" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="architecture_after_change" align="center" label="架构(变更后)">
								<template slot-scope="scope">
									<el-input v-model="scope.row.architecture_after_change" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="notes" align="center" label="备注">
								<template slot-scope="scope">
									<el-input v-model="scope.row.notes" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="riginal_budget_number" align="center" label="原预算单编号">
								<template slot-scope="scope">
									<el-input v-model="scope.row.riginal_budget_number" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="new_budget_number" align="center" label="新预算单编号">
								<template slot-scope="scope">
									<el-input v-model="scope.row.new_budget_number" size="small"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" label="操作" width="80">
								<template slot-scope="scope">
									<img src="../../../assets/删除.png" @click="Del(scope.row)" />
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				total: 0,
				ids: [],
				projectList: [],
				//条件
				formInline: {
					budgetSplit: {},
					detailedList: [{
						budget_classification: '',
						budget_name: '',
						year_change: '',
						change_month: '',
						pre_change_architecture: '',
						architecture_after_change: '',
						notes: '',
						riginal_budget_number: '',
						new_budget_number: '',
					}],
				},
			};
		},
		methods: {
			async proClick(val){
				var data = await this.$globals.AxiosGet("budgetForm/getName?info=" + val);
						this.formInline.budgetSplit.group_structure = data.data;
			},
			addtable() {
				const newLine = {
					budget_classification: '',
					budget_name: '',
					year_change: '',
					change_month: '',
					pre_change_architecture: '',
					architecture_after_change: '',
					notes: '',
					riginal_budget_number: '',
					new_budget_number: '',
				}
				this.index++
				this.formInline.detailedList.push(newLine)
			},
			async Add() {
				var data = await this.$globals.AxiosPost('budgetSplit/add', this.formInline);
				if (data.code === '200') {
					this.$message.success('保存成功！');
					this.Find();
					this.formInline.detailedList = [];
					this.addtable()
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			},
			Del(e) {
				if(this.formInline.detailedList.length != 1){
					this.formInline.detailedList.splice(e, 1);
				}else{
					this.$message.warning('请至少保留一条数据！');
				}
			},
			async Find() {
				var data = await this.$globals.AxiosGet('budgetSplit/numberCode');
				this.formInline.budgetSplit = data.data;
			}

		},
		async created() {
			this.Find()
			var projectList = await this.$globals.AxiosPost("tenderHonourAgreement/getProjectList", {});
			this.projectList = projectList.data;
		},
	};
</script>

<style scoped>
	.findcontent {
		border: 1px solid #006e4b;
		background-color: #fafff9;
		padding: 10px 20px;
		margin: 0 30px;
	}

	.findTitle {
		font-size: 18px;
		font-weight: 600;
		color: #006e4b;
		margin-top: 10px;
	}

	.formlist {
		margin-top: 10px
	}

	.btnicon {
		display: flex;
		margin: 20px 0 10px 10px;
	}

	.btnview {
		margin-left: 20px;
	}

	.tabs {
		margin: 0 30px;
	}
</style>
<style>
	.tabs .el-tabs--border-card>.el-tabs__header {
		background-color: #fafafa;
	}

	.tabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
		border-top: 3px solid #006e4b;
	}

	.tabs .el-tabs--border-card>.el-tabs__content {
		padding: 15px 0;
	}
</style>



// WEBPACK FOOTER //
// Budsplitting.vue?55829fb4